import { useEffect, useState } from 'react'
import { Select } from 'antd'
import { toast } from 'react-hot-toast'
import { useLocation, useNavigate } from 'react-router-dom'
import { ButtonFilledAutoWidth } from '../../components/button'
import { TextAreaInput1, TextInput } from '../../components/input'
import GoBack from '../../components/back/GoBack'
import { GetFileStandardService } from '../../services/admin/FileStandardServices'
import { CreateChapterService, UpdateChapterService } from '../../services/admin/ChapterServices'
import { GetSubjectService } from '../../services/admin/SubjectServices'
import SettingsMenu from '../staticscreens/SettingsMenu'

function ChapterCE() {
    const [data, setdata] = useState({
        filter_standard: undefined,
        subject: undefined,
        chapter_number: '',
        title: '',
        description: '',
        review_status: 'pending',
        is_free: false
    })
    const [error, seterror] = useState({ subject: '', chapter_number: '', title: '' })
    const [standards, setstandards] = useState([])
    const [subjects, setsubjects] = useState([])

    const { state } = useLocation()
    const navigate = useNavigate()

    useEffect(() => {
        getStandards()
    }, [])

    useEffect(() => {
        if (!state?._id) {
            return
        }

        setdata((prev) => ({
            ...prev,
            ...state,
            filter_standard: state?.subject?.filter_standard || undefined,
            subject: state?.subject?._id || undefined,
            chapter_number: state?.chapter_number ?? '',
            title: state?.title || '',
            description: state?.description || '',
            review_status: state?.review_status || 'pending',
            is_free: Boolean(state?.is_free)
        }))
    }, [state])

    useEffect(() => {
        getSubjects(data.filter_standard)
    }, [data.filter_standard])

    async function getStandards() {
        const response = await GetFileStandardService()
        setstandards((response?.data?.datas || []).map((item) => ({
            value: item._id,
            label: item.standard || item.label,
            data: item
        })))
    }

    async function getSubjects(filter_standard = '') {
        const response = await GetSubjectService(filter_standard ? { filter_standard } : {})
        const subjectOptions = (response?.data?.datas || []).map((item) => ({
            value: item._id,
            label: item.name,
            data: item
        }))
        setsubjects(subjectOptions)

        setdata((prev) => {
            if (prev.subject && !subjectOptions.find((item) => item.value === prev.subject)) {
                return { ...prev, subject: undefined }
            }
            return prev
        })
    }

    function handlechange(e) {
        setdata((prev) => ({ ...prev, [e.target.name]: e.target.value }))
        seterror((prev) => ({ ...prev, [e.target.name]: '' }))
    }

    async function submitform() {
        if (!data.subject) {
            seterror((prev) => ({ ...prev, subject: 'Subject field is required *' }))
            return
        }

        if (data.chapter_number === '') {
            seterror((prev) => ({ ...prev, chapter_number: 'Chapter number is required *' }))
            return
        }

        if (!data.title?.trim()) {
            seterror((prev) => ({ ...prev, title: 'Title field is required *' }))
            return
        }

        const send_data = {
            subject: data.subject,
            chapter_number: Number(data.chapter_number),
            title: data.title,
            review_status: data.review_status,
            is_free: data.is_free
        }

        if (data.description?.trim()) {
            send_data.description = data.description
        }

        if (!state?._id) {
            const response = await CreateChapterService(send_data)
            if (response?.status === 201) {
                resetform()
                toast.success('Chapter Created Successfully')
            }
            return
        }

        const response = await UpdateChapterService(send_data, state?._id)
        if (response?.status === 200) {
            resetform()
            navigate(-1)
            toast.success('Chapter Updated Successfully')
        }
    }

    function resetform() {
        setdata({
            filter_standard: undefined,
            subject: undefined,
            chapter_number: '',
            title: '',
            description: '',
            review_status: 'pending',
            is_free: false
        })
        seterror({ subject: '', chapter_number: '', title: '' })
    }

    return (
        <div className='md:flex'>
            <div className='hidden md:block'>
                <SettingsMenu />
            </div>
            <div className='sm:w-full lg:w-80 px-4 pt-5'>
                <GoBack />

                <h6 className='font-[700]'>{state?._id ? 'Edit' : 'Add'} Chapter</h6>
                <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug'>Use the below form to create or edit the <b>Chapter</b> after selecting a filter standard and subject.</h6>

                <div>
                    <h6 className='text-[11px] mb-1 mt-2'>Filter Standard</h6>
                    <Select
                        value={data.filter_standard}
                        allowClear
                        bordered={false}
                        placeholder=''
                        onChange={(value) => setdata((prev) => ({ ...prev, filter_standard: value || undefined, subject: undefined }))}
                        options={standards}
                        className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-transparent'
                    />
                </div>

                <div>
                    <h6 className='text-[11px] mb-1 mt-2'>Subject</h6>
                    <Select
                        value={data.subject}
                        allowClear
                        bordered={false}
                        placeholder=''
                        onChange={(value) => {
                            setdata((prev) => ({ ...prev, subject: value || undefined }))
                            seterror((prev) => ({ ...prev, subject: '' }))
                        }}
                        options={subjects}
                        className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-transparent'
                    />
                    {error.subject && <h6 className='text-[10px] text-red-500 mt-1'>{error.subject}</h6>}
                </div>

                <TextInput
                    label={'Chapter Number'}
                    variant='standard'
                    name='chapter_number'
                    type='number'
                    error={error.chapter_number}
                    value={data.chapter_number}
                    handlechange={handlechange}
                    placeholder='Enter chapter number'
                    InputLabelProps={{ style: { color: '#fff' } }}
                />

                <TextInput
                    label={'Title'}
                    variant='standard'
                    name='title'
                    type='text'
                    error={error.title}
                    value={data.title}
                    handlechange={handlechange}
                    placeholder=''
                    InputLabelProps={{ style: { color: '#fff' } }}
                />

                <TextAreaInput1
                    label={'Description'}
                    variant='standard'
                    name='description'
                    type='text'
                    value={data.description}
                    handlechange={handlechange}
                    placeholder=''
                    InputLabelProps={{ style: { color: '#fff' } }}
                />

                <div>
                    <h6 className='text-[11px] mb-1 mt-2'>Review Status</h6>
                    <Select
                        value={data.review_status}
                        bordered={false}
                        onChange={(value) => setdata((prev) => ({ ...prev, review_status: value }))}
                        options={[
                            { value: 'pending', label: 'Pending' },
                            { value: 'under_review', label: 'Under Review' },
                            { value: 'accepted', label: 'Accepted' },
                            { value: 'rework', label: 'Rework' },
                            { value: 'rejected', label: 'Rejected' }
                        ]}
                        className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-transparent'
                    />
                </div>

                <div>
                    <h6 className='text-[11px] mb-1 mt-2'>Free Chapter</h6>
                    <Select
                        value={data.is_free}
                        bordered={false}
                        onChange={(value) => setdata((prev) => ({ ...prev, is_free: value }))}
                        options={[
                            { value: true, label: 'Yes' },
                            { value: false, label: 'No' }
                        ]}
                        className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-transparent'
                    />
                </div>

                <div className='mt-5'>
                    <ButtonFilledAutoWidth btnName={state?._id ? 'UPDATE CHAPTER' : 'ADD CHAPTER'} onClick={submitform} />
                </div>
            </div>
        </div>
    )
}

export default ChapterCE
